export const GA_ACCOUNT = 'G-BY16GDRCV4'

export const ANALYTICS__FAILURE = 'analyticsFailure'
export const ANALYTICS__SUCCESS = 'analyticsSuccess'
